/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography, Typography2, breakpoints } from '@coursera/cds-core';

import { useDegreeDescriptionPageTheme } from 'bundles/degree-description/degreeDescriptionPageTheme';


const styles = {
  outerContainer: () => css`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  `,
  notFirstOuter: () => css`
    ${breakpoints.down('sm')} {
      border-top: 2px solid var(--cds-color-neutral-stroke-primary-weak);
      padding-top: var(--cds-spacing-150);
    }

    span {
      ${breakpoints.up('md')} {
        border-left: 2px solid transparent;
        padding-left: var(--cds-spacing-400);
      }
    }
  `,
  innerContainer: () => css`
    flex-grow: 1;
    ${breakpoints.up('md')} {
      padding: var(--cds-spacing-100) 0;
    }
  `,
  notFirstInner: () => css`
    ${breakpoints.up('md')} {
      border-left: 2px solid var(--cds-color-neutral-stroke-primary-weak);
      padding-left: var(--cds-spacing-400);
    }
  `,
  hideOnMobile: () => css`
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
  hideOnDesktop: () => css`
    ${breakpoints.up('md')} {
      display: none;
    }
  `,
};

type Props = {
  number: number;
  title: string;
  description: string;
};

const EnrollStep = (props: Props): React.ReactElement => {
  const { number, title, description } = props;

  const theme = useDegreeDescriptionPageTheme();
  return (
    <Grid item container md>
      <div css={[styles.outerContainer, number !== 1 && styles.notFirstOuter]}>
        <Typography
          variant="h1semibold"
          component="span"
          css={[theme.mobileFontSizeStyle?.header, styles.hideOnMobile]}
          aria-hidden="true"
        >
          {number}.
        </Typography>
        <div css={[styles.innerContainer, number !== 1 && styles.notFirstInner]}>
          <Typography2
            variant="subtitleMedium"
            component="h3"
            css={[theme.mobileFontSizeStyle?.header, styles.hideOnMobile]}
            aria-label={`${number}. ${title}`}
          >
            {title}
          </Typography2>
          <Typography2
            variant="subtitleMedium"
            component="h3"
            css={[theme.mobileFontSizeStyle?.header, styles.hideOnDesktop]}
          >
            {number}. {title}
          </Typography2>
          <Typography2 component="p" css={theme.mobileFontSizeStyle?.body}>
            {description}
          </Typography2>
        </div>
      </div>
    </Grid>
  );
};

export default EnrollStep;
